import { DatePicker, Form } from "antd";
import { Rule } from "antd/es/form";
import { useMemo } from "react";

const { RangePicker } = DatePicker;

export const PeriodItem = () => {
  const rules: Rule[] = useMemo(
    () => [
      {
        required: true,
      },
    ],
    []
  );

  return (
    <Form.Item
      label="Period"
      name="dates"
      className="mb-6 period-picker"
      rules={rules}
    >
      <RangePicker picker="year" />
    </Form.Item>
  );
};
